

// ─── Raw scale (numbers, in px) ─────────────────────────────────────────────
export const fontSizeScale = {
  dataLabel: 12,
  sectionHeading: 14,
  tabLabel: 14,
  breadcrumb: 14,
  body: 13,
  caption: 11,
  button: 11,
  dialogTitle: 14,
  pageTitle: 16,
  subHeading: 13,
  icon: 18,           // standard inline icon size (menu icons, list icons)
};

// ─── String versions (append 'px') ──────────────────────────────────────────
export const fontSize = {};
for (const k in fontSizeScale) {
  if (Object.prototype.hasOwnProperty.call(fontSizeScale, k)) {
    fontSize[k] = `${fontSizeScale[k]}px`;
  }
}

// ─── Font weights ────────────────────────────────────────────────────────────
export const fontWeight = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

// ─── Line heights ────────────────────────────────────────────────────────────
export const lineHeight = {
  tight: 1.2,
  normal: 1.4,
  relaxed: 1.6,
};

// ─── Convenience composite object (for makeStyles / sx) ─────────────────────
export const typography = {
  fontSize,
  fontSizeScale,
  fontWeight,
  lineHeight,
};


export default typography;
